__turbopack_context__.v({
  "nestedSection": "TermsCondition-module__7N2vKW__nestedSection",
  "nextParagraph": "TermsCondition-module__7N2vKW__nextParagraph",
  "nextSubheading": "TermsCondition-module__7N2vKW__nextSubheading",
  "nextTermscontainer": "TermsCondition-module__7N2vKW__nextTermscontainer",
  "nextTitle": "TermsCondition-module__7N2vKW__nextTitle",
});
